module.exports = __webpack_public_path__ + "img/platform-demo.dad4240a.gif";